"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.conjDependencies = void 0;

var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");

var _factoriesAny = require("../../factoriesAny.js");

/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
var conjDependencies = {
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createConj: _factoriesAny.createConj
};
exports.conjDependencies = conjDependencies;